import React, { Component } from "react";
import { connect } from "react-redux";
import { Grid, Row, Col, OverlayTrigger, Popover } from "react-bootstrap";
import "react-confirm-alert/src/react-confirm-alert.css";
import { Card } from "components/Card/Card.jsx";
import { withRouter } from "react-router-dom";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { FormInputs } from "components/FormInputs/FormInputs.jsx";
import { Link } from "react-router-dom";
import { createOrderActions } from "../../../redux/actions/create-order-actions";
import { SC } from "helper/ServerCall";
import { confirmAlert } from 'react-confirm-alert';
import Confirmalertfordelete from '../../ThemeComponents/confirmAlertForDelete';
import { alertActions } from "../../../redux/actions/alert-actions";


class CartsList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            addModalState: false,
            editModalState: false,
            sorted: "",
            filtered: "",
            brandId: "",
            pageSize: 10,
            orders: [],
            checked: "",
            page: 1,
            selected_orders: [],
            showDropdown: this.props.match.params.id !== "all" ? true : true,
        };
    }

    refreshOrdersList = () => {
        this.props
            .getCartsListCall(
                this.state.page,
                this.state.filtered,
                this.state.pageSize
            );
    };
    componentDidMount = () => {
        this.refreshOrdersList();
    }

    filterSearchHandle = (e) => {
        this.setState(
            {
                filtered: e.target.value
            },
            () => {
                this.refreshOrdersList();
            }
        );
    }

    ordersPaginationData = (page, sort, pageSize) => {
        if (page !== this.state.page) {
            this.setState({ page: page }, () => {
                this.refreshOrdersList();
            });
        }
    };

    deleteConfirmation = (id, short_code) => {
        confirmAlert({
          customUI: ({ onClose }) => {
            return (
              <Confirmalertfordelete  typeName={'cart'}  onClosePro={onClose} deleteType={() => this.deleteCart(id, short_code)} />
            )
          }
        })
      }

    deleteCart = async (id, short_code) => {
        const res = await SC.postCall(`orders/cart/${id}`, {short_code});
        this.props.alertNote(res.message)
        this.refreshOrdersList();
    }
    render() {
        const { filtered } = this.state;
        const { pages, loading, cartsListData } = this.props;
        const columns = [
            {
                Header: "States Listing",
                headerClassName: "headerPagination",
                columns: [
                    {
                        Header: "Ref #",
                        accessor: "id",
                        className: "action-center"
                    },
                    {
                        Header: "Username",
                        accessor: "user_name",
                        className: "action-center"
                    },
                    {
                        Header: "Email",
                        accessor: "user_email",
                        className: "action-center"
                    },
                    {
                        Header: "Brand",
                        accessor: "brand",
                        className: "action-center"
                    },
                    {
                        Header: "Items Count",
                        accessor: "items_count",
                        className: "action-center"
                    },
                    {
                        Header: "Date Created",
                        accessor: "created_at",
                        className: "action-center"
                    },
                    {
                        Header: "Actions",
                        accessor: "id",
                        Cell: ({ value, original }) => (
                            <div>
                                <OverlayTrigger placement="bottom" overlay={<Popover id="tooltip">{`View Cart`}</Popover>}>
                                    <span>
                                        {
                                            <Link to={`/Admin/cart/${value}/view`}>
                                                <button type='button' className="viewIcon orderDetailsAction">&nbsp;</button>
                                            </Link>
                                        }
                                    </span>
                                </OverlayTrigger>
                                <OverlayTrigger placement="bottom" overlay={<Popover id="tooltip">{`Delete Cart`}</Popover>}>
                                    <span>
                                        <button type='button' className="deleteIcon orderDetailsAction" onClick={() => this.deleteConfirmation(value, original.brand_detail.short_code || '')}>&nbsp;</button>
                                    </span>
                                </OverlayTrigger>
                            </div>
                        ),
                        className: "action-center",
                        sortable: false
                    }
                ]
            }
        ];

        return (
            <div className="content">
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card
                                ctTableResponsive
                                content={
                                    <div>
                                        <Grid fluid>
                                            <Row>
                                                <Col md={12}>
                                                    <h3
                                                        style={{
                                                            textAlign: "center",
                                                            fontWeight: "500",
                                                            textTransform:
                                                                "capitalize"
                                                        }}
                                                    >
                                                        Open Carts
                                                    </h3>
                                                </Col>

                                                <Col md={12}>
                                                    <div
                                                        className="flexElem mt-xlg flexResponsive"
                                                        style={{
                                                            alignItems:
                                                                "flex-start",
                                                            justifyContent:
                                                                "space-between"
                                                        }}
                                                    >
                                                        <div className="block">

                                                        </div>

                                                        <div className="custom-search-input">
                                                            <FormInputs
                                                                ncols={[
                                                                    "col-md-12"
                                                                ]}
                                                                onChange={
                                                                    this
                                                                        .filterSearchHandle
                                                                }
                                                                proprieties={[
                                                                    {
                                                                        type:
                                                                            "text",
                                                                        bsClass:
                                                                            "form-control",
                                                                        placeholder:
                                                                            "Search Carts",
                                                                        onChange: this
                                                                            .filterSearchHandle,
                                                                        name:
                                                                            "filter"
                                                                    }
                                                                ]}
                                                            />
                                                        </div>
                                                    </div>
                                                </Col>

                                                <Col md={12} className="mt-md">
                                                    <ReactTable
                                                        noDataText="No matching records found"
                                                        data={cartsListData}
                                                        pages={pages}
                                                        loading={loading}
                                                        columns={columns}
                                                        filtered={filtered}
                                                        defaultPageSize={10}
                                                        className="-striped listing responsive"
                                                        pageData={
                                                            this
                                                                .ordersPaginationData
                                                        }
                                                        manual
                                                        onFetchData={(
                                                            state,
                                                            instance
                                                        ) => {
                                                            var sort =
                                                                state.sorted
                                                                    .length ===
                                                                    0
                                                                    ? ""
                                                                    : state
                                                                        .sorted[0]
                                                                        .id +
                                                                    ",desc:" +
                                                                    state
                                                                        .sorted[0]
                                                                        .desc;
                                                            state.pageData(
                                                                state.page + 1,
                                                                state.filtered,
                                                                sort,
                                                                state.pageSize
                                                            );
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                        </Grid>
                                    </div>
                                }
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getCartsListCall: (
            page,
            filter,
            pageSize
        ) => {
            return dispatch(
                createOrderActions.getCartsList(
                    page,
                    filter,
                    pageSize
                )
            );
        },
        alertNote: (data) => { dispatch(alertActions.success(data)) },
    };
};

function mapStateToProps(state) {
    const {
        cartsListData,
        pages,
        loadingOrder,
        current_page,
        total_orders
    } = state.ordersReducer;

    return {
        loading: loadingOrder,
        cartsListData,
        pages,
        current_page,
        total_orders,
    };
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(CartsList)
);



// WEBPACK FOOTER //
// ./src/components/Admin/Order/CartsList.jsx